import React, { useState, useEffect, useRef } from "react";
import { Modal } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { portfolioImgSrc } from "../../secondUtils/constants";

const PortfolioModal = ({ isModalOpen, handleOk, handleCancel, imgUrl }) => {
    const [togglePreview, setTogglePreview] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);

    useEffect(() => {
        const index = portfolioImgSrc.findIndex(image => image === imgUrl);
        if (index !== -1) {
            setCurrentSlide(index);
            setTogglePreview(index >= 7 && index <= 11);
            if (sliderRef.current) {
                sliderRef.current.slickGoTo(index);
            }
        }
    }, [imgUrl]);

    const CustomNextArrow = ({ onClick }) => (
        <div className="portfolio-img-arrow portfolio-right" onClick={onClick}>
            <FaChevronRight />
        </div>
    );

    const CustomPrevArrow = ({ onClick }) => (
        <div className="portfolio-img-arrow portfolio-left" onClick={onClick}>
            <FaChevronLeft />
        </div>
    );

    const settings = {
        initialSlide: currentSlide,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        afterChange: (current) => setCurrentSlide(current)
    };

    const handlePreviewNext = () => {
        setTogglePreview(prev => !prev);
    };

    const handlePreviewPrev = () => {
        setTogglePreview(prev => !prev);
    };

    const previewImages = togglePreview ? portfolioImgSrc.slice(7, 12) : portfolioImgSrc.slice(0, 7);

    return (
        <div className="portfolio-modal-main">
            <Modal open={isModalOpen} footer={null} onCancel={handleCancel}>
                <Slider ref={sliderRef} {...settings}>
                    {portfolioImgSrc.map((imageUrl, index) => (
                        <div key={index} className='portfolioModal-slide-item'>
                            <img src={imageUrl} alt={`Image ${index + 1}`} />
                        </div>
                    ))}
                </Slider>
                <div className="portfolioModal-small-img-div">
                    <button onClick={handlePreviewPrev}><FaChevronLeft /></button>
                    {previewImages.map((image, index) => (
                        <div key={index} onClick={() => {
                            setCurrentSlide(index + (togglePreview ? 7 : 0));
                            sliderRef.current.slickGoTo(index + (togglePreview ? 7 : 0));
                        }}>
                            <img
                                className={`portfolioModal-small-image ${currentSlide === index + (togglePreview ? 7 : 0) ? 'active' : ''}`}
                                src={image}
                                alt={`Preview ${index}`}
                            />
                        </div>
                    ))}
                    <button onClick={handlePreviewNext}><FaChevronRight /></button>
                </div>
            </Modal>
        </div>
    );
};

export default PortfolioModal;
